// japanese_viseme_to_romaji
const japaneseVisemeToRomaji = {
    "19,2": "su",
    "20,2": "su",
    "15,2": "su",
    "12,2": "su",
    "21,2": "ma",
    "6,2": "su",
    "7,2": "su",
    "6,6": "su",
    "20,6": "su",
    "16,6": "su",
    "19,6": "su",
    "12,6": "su",
    "21,6": "su",
    "7,6": "su",
    "15,6": "su",
    "19,15,6": "su",
    "6,6": "su",
    "19,4": "su",
    "20,4": "su",
    "15,4": "su",
    "12,4": "su",
    "21,4": "su",
    "19,8": "o",
    "20,8": "o",
    "15,8": "o",
    "12,8": "o",
    "21,8": "o",
    "6,8": "o",
    "20,6,2": "su",
    "20,6,6": "su",
    "20,6,8": "o",
    "16,6,2": "su",
    "16,6,6": "su",
    "16,6,8": "o",
    "19,6,2": "su",
    "19,6,6": "su",
    "19,6,8": "o",
    "12,6,2": "su",
    "12,6,6": "su",
    "12,6,8": "o",
    "21,6,2": "su",
    "21,6,6": "su",
    "21,6,8": "o"
};

// complex_japanese_viseme_to_romaji
const complexJapaneseVisemeToRomaji = {
    "19,2": "a/ta/na/ra",
    "20,2": "ka",
    "15,2": "sa",
    "12,2": "ha",
    "21,2": "ma",
    "6,2": "ya",
    "7,2": "wa",
    "6,6": "i",
    "20,6": "ki",
    "16,6": "shi/chi",
    "19,6": "ni/ri/nu/ru",
    "12,6": "hi/fu",
    "21,6": "mi/mu",
    "7,6": "u",
    "15,6": "su",
    "19,15,6": "tsu",
    "6,6": "yu",
    "19,4": "e/te/ne/re",
    "20,4": "ke",
    "15,4": "se",
    "12,4": "he",
    "21,4": "me",
    "19,8": "o/to/no/ro/wo",
    "20,8": "ko",
    "15,8": "so",
    "12,8": "ho",
    "21,8": "mo",
    "6,8": "yo",
    "19": "n",
    "20,6,2": "kya/gya",
    "20,6,6": "kyu/gyu",
    "20,6,8": "kyo/gyo",
    "16,6,2": "sha/cha/ja/dya",
    "16,6,6": "shu/chu/ju/dyu",
    "16,6,8": "sho/cho/jo/dyo",
    "19,6,2": "nya/rya",
    "19,6,6": "nyu/ryu",
    "19,6,8": "nyo/ryo",
    "12,6,2": "hya",
    "12,6,6": "hyu",
    "12,6,8": "hyo",
    "21,6,2": "mya/bya/pya",
    "21,6,6": "myu/byu/pyu",
    "21,6,8": "myo/byo/pyo"
};

// romaji_to_imageClip_dic
const romajiToImageClipDic = {
    "a": "ka",
    "ka": "ka",
    "ta": "ka",
    "na": "ka",
    "ha": "ka",
    "ra": "ka",
    "ma": "ba",
    "wa": "wa",
    "ya": "ka",
    "sa": "ka",
    "i": "i",
    "ki": "i",
    "shi": "i",
    "chi": "i",
    "ni": "i",
    "hi": "i",
    "ri": "i",
    "mi": "bi",
    "u": "su",
    "ku": "su",
    "fu": "su",
    "ru": "su",
    "nu": "su",
    "su": "su",
    "tsu": "su",
    "mu": "bu",
    "yu": "yo",
    "me": "me",
    "e": "ke",
    "ke": "ke",
    "te": "ke",
    "ne": "ke",
    "he": "ke",
    "re": "ke",
    "se": "ke",
    "o": "o",
    "ko": "o",
    "no": "o",
    "ho": "o",
    "mo": "o",
    "ro": "o",
    "wo": "o",
    "to": "o",
    "so": "o",
    "yo": "yo",
    "kya": "ka",
    "gya": "ka",
    "kyu": "yo",
    "gyu": "yo",
    "kyo": "yo",
    "gyo": "yo",
    "sha": "sa",
    "cha": "sa",
    "ja": "sa",
    "dya": "sa",
    "shu": "su",
    "chu": "su",
    "ju": "su",
    "dyu": "su",
    "sho": "o",
    "cho": "o",
    "jo": "o",
    "dyo": "o",
    "nya": "ya",
    "rya": "ya",
    "nyu": "yo",
    "ryu": "yo",
    "nyo": "yo",
    "ryo": "yo",
    "hya": "ya",
    "hyu": "yo",
    "hyo": "yo",
    "mya": "ba",
    "bya": "ba",
    "pya": "ba",
    "myu": "bu",
    "byu": "bu",
    "pyu": "bu",
    "myo": "bo",
    "byo": "bo",
    "pyo": "bo"
};

// closed_mouth_sounds
const closedMouthSounds = new Set([
    "wa",
    "ba",
    "me",
    "bi",
    "bo",
    "bu"
]);

// sound_simplify_set
const soundSimplifySet = new Set([
    ["se", "yu"].toString(),
    ["e/te/ne/re", "yu"].toString(),
    ["yu", "e/te/ne/re"].toString(),
    ["a/ta/na/ra", "yu"].toString(),
    ["ma", "yu"].toString(),
    ["ka", "yu"].toString(),
    ["ko", "u"].toString(),
    ["yo", "u"].toString(),
    ["yo", "yu"].toString(),
    ["e/te/ne/re", "ni/ri/nu/ru"].toString(),
    ["se", "shi/chi"].toString(),
    ["shi/chi", "e/te/ne/re"].toString(),
    ["o/to/no/ro/wo", "u"].toString(),
    ["e/te/ne/re", "ki"].toString(),
    ["a/ta/na/ra", "e/te/ne/re"].toString(),
    ["e/te/ne/re", "a/ta/na/ra"].toString(),
    ["tsu", "ni/ri/nu/ru"].toString(),
    ["o/to/no/ro/wo", "nyo/ryo"].toString(),
    ["ho", "yo"].toString(),
    ["nyu/ryu", "ni/ri/nu/ru"].toString(),
    ["ke", "shi/chi"].toString(),
    ["ke", "ni/ri/nu/ru"].toString()
]);

// viseme_skip_dic
const visemeSkipDic = {
    "ka": [4, 7],
    "ba": [0, 5],
    "wa": [0, 8],
    "ya": [4, 9],
    "sa": [8, 14],
    "i": [2, 5],
    "bi": [0, 7],
    "o": [2, 7],
    "yo": [3, 11],
    "bo": [0, 8],
    "me": [0, 9],
    "ke": [4, 9],
    "ku": [4, 11],
    "su": [3, 10],
    "bu": [0, 8]
};

// viseme 데이터를 받아 imageClip 시퀀스로 변환
export function viseme2imageClip(visemeData) {
    if (!visemeData || visemeData.length === 0) return [];

    const imageClips = [];
    let i = 0;
    const visemeName = visemeData[0].hasOwnProperty('viseme') ? 'viseme' : 'id';
    const offsetName = 'offset';
    const timeMultiplier = 1;

    function canMatchFurther(remainingVisemes) {
        if (remainingVisemes.length >= 3) {
            const triple = [remainingVisemes[0][visemeName], remainingVisemes[1][visemeName], remainingVisemes[2][visemeName]].join(',');
            if (japaneseVisemeToRomaji[triple]) return true;
        }
        if (remainingVisemes.length >= 2) {
            const pair = [remainingVisemes[0][visemeName], remainingVisemes[1][visemeName]].join(',');
            if (japaneseVisemeToRomaji[pair]) return true;
        }
        if (remainingVisemes.length >= 1) {
            if (remainingVisemes[0][visemeName] === 0) return true;
        }
        return false;
    }

    while (i < visemeData.length) {
        const visemeId = visemeData[i][visemeName];
        const startOffset = visemeData[i][offsetName] / timeMultiplier;
        const endOffset = (i + 1 < visemeData.length)
            ? visemeData[i + 1][offsetName] / timeMultiplier
            : startOffset + 0.1;

        console.log(`Processing viseme: ${visemeId}, start: ${startOffset}, end: ${endOffset}`);

        // triple
        if (i + 2 < visemeData.length) {
            const tripleKey = [visemeData[i][visemeName], visemeData[i + 1][visemeName], visemeData[i + 2][visemeName]].join(',');
            if (japaneseVisemeToRomaji[tripleKey]) {
                const nextStart = i + 3;
                const remainingVisemes = visemeData.slice(nextStart);
                if (canMatchFurther(remainingVisemes)) {
                    const romaji = japaneseVisemeToRomaji[tripleKey];
                    const imageClipPath = romajiToImageClipDic[romaji.split('/')[0]];
                    imageClips.push([imageClipPath, romaji, tripleKey, startOffset, visemeData[nextStart]?.[offsetName] / timeMultiplier]);
                    i += 3;
                    continue;
                }
            }
        }

        // pair
        if (i + 1 < visemeData.length) {
            const pairKey = [visemeData[i][visemeName], visemeData[i + 1][visemeName]].join(',');
            if (japaneseVisemeToRomaji[pairKey]) {
                const romaji = japaneseVisemeToRomaji[pairKey];
                const imageClipPath = romajiToImageClipDic[romaji.split('/')[0]];
                imageClips.push([imageClipPath, romaji, pairKey, startOffset, (i + 2 < visemeData.length) ? visemeData[i + 2][offsetName] / timeMultiplier : endOffset]);
                i += 2;
                continue;
            }
        }

        // single
        const singleKey = [visemeId].join(',');
        if (japaneseVisemeToRomaji[singleKey]) {
            // 단일 viseme 처리
            if (imageClips.length > 0) {
                const prev = imageClips.pop();
                imageClips.push([prev[0], prev[1], prev[2], prev[3], endOffset]);
            }
            i += 1;
        } else {
            i += 1;
        }
    }
    return imageClips;
}

// imageClip 시퀀스 후처리
export function processImageClipSequence(imageClips) {
    const result = [];
    const n = imageClips.length;
    for (let i = 0; i < n; i++) {
        const [curImageClipPath, curRomaji, _, curStartTime, curEndTime] = imageClips[i];
        const curStartFrame = (i === 0 || closedMouthSounds.has(curImageClipPath)) ? 0 : visemeSkipDic[curImageClipPath][0] + 1;
        const curEndFrame = (i === n - 1) ? 0 : visemeSkipDic[curImageClipPath][1] + 1;

        if (i === 0) {
            result.push([curStartTime, curEndTime, curImageClipPath, curStartFrame, curEndFrame, curRomaji]);
        } else {
            const [prevStartTime, prevEndTime, prevImageClipPath, prevStartFrame, prevEndFrame, prevRomaji] = result[result.length - 1];
            if (prevEndTime !== curStartTime) {
                result[result.length - 1] = [prevStartTime, prevEndTime, prevImageClipPath, prevStartFrame, 0, prevRomaji];
                result.push([curStartTime, curEndTime, curImageClipPath, 0, curEndFrame, curRomaji]);
                continue;
            }
            if (prevImageClipPath === curImageClipPath || soundSimplifySet.has([prevRomaji, curRomaji].toString())) {
                result[result.length - 1] = [prevStartTime, curEndTime, prevImageClipPath, prevStartFrame, prevEndFrame, prevRomaji];
            } else if (!closedMouthSounds.has(curImageClipPath)) {
                const transitionStart = prevStartTime + (prevEndTime - prevStartTime) * 0.75;
                const transitionEnd = curStartTime + (curEndTime - curStartTime) * 0.25;
                result[result.length - 1] = [prevStartTime, transitionStart, prevImageClipPath, prevStartFrame, prevEndFrame, prevRomaji];
                result.push([transitionStart, transitionEnd, `${prevImageClipPath}2${curImageClipPath}`, 0, 0, `${prevImageClipPath}2${curImageClipPath}`]);
                result.push([transitionEnd, curEndTime, curImageClipPath, curStartFrame, curEndFrame, curRomaji]);
            } else {
                result[result.length - 1] = [prevStartTime, prevEndTime, prevImageClipPath, prevStartFrame, 0, prevRomaji];
                result.push([curStartTime, curEndTime, curImageClipPath, 0, curEndFrame, curRomaji]);
            }
        }
    }
    return result;
}

// 전체 변환 함수
export function jpnVisemeToImageClipSequence(visemeData) {
    const imageClips = viseme2imageClip(visemeData);
    const simplifiedImageClips = processImageClipSequence(imageClips);
    return simplifiedImageClips;
}
